import { render, staticRenderFns } from "./InlineNested.vue?vue&type=template&id=b0ba7422&"
import script from "./InlineNested.vue?vue&type=script&lang=js&"
export * from "./InlineNested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports